import { render } from "./MailSender.vue?vue&type=template&id=60290abf&scoped=true&ts=true"
import script from "./MailSender.vue?vue&type=script&lang=ts"
export * from "./MailSender.vue?vue&type=script&lang=ts"

import "./MailSender.vue?vue&type=style&index=0&id=60290abf&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\Administrator\\Documents\\Repos\\PROD-license-management\\redesign\\WebUI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60290abf"]])

export default __exports__